import styled from "styled-components";

const SpanText = styled.span`
    font-size: 0.85rem;
    margin: 0.25rem;
`;

export const DivCenter = styled.div`
    display: flex;
    align-items: center;
`;

export const UlStyled = styled.ul`
    margin: 0.25rem;

    >li{
        font-size: 0.85rem;
    }
`;

export default SpanText;
